import Vue from "vue";
import qs from "qs";
import requests from "./requset";

// API base URL from environment variable
// Development: https://apply.24cod.com (see .env.development)
// Production:  http://yjs.jxdx.gov.cn  (see .env.production)
const API_BASE = process.env.VUE_APP_API_BASE_URL || "https://apply.24cod.com"
Vue.prototype.$pre = API_BASE
Vue.prototype.$common_upload = API_BASE + "/api/common/upload"

//项目初始化
export let initProject = () => {
    return requests({
        url: "/api/apply.init/init",
        method: "get"
    })
}

/**********************用户模块********************/
//用户注册
export let reqUserRegister = (data) => {
    return requests({
        url: "/api/user/register",
        method: "post",
        data: qs.stringify(data)
    })
}
//图片验证码
export let getCaptId = () => {
    return requests({
        url: "/api/common/captchapre",
        method: "get",
        // params:userParams  
    })
}
export let getCapt = (id) => {
    return requests({
        url: "/api/common/captcha",
        method: "get",
        params: {
            captcha_id: id
        }
    })
}
//用户登录
export let reqUserLogin = (data) => {
    return requests({
        url: "/api/user/safelogin",
        method: "post",
        data: qs.stringify(data)
    })
}

//用户信息
export let reqUserInfo = () => {
    return requests({
        url: "/api/user/getinfo",
        method: "get"
    })
}



//用户重置密码
export let reqResetPassword = (data) => {
    return requests({
        url: "/api/user/resetpwd",
        method: "post",
        data: qs.stringify(data)
    })
}


//获取通用短信验证码
export let getCode = (obj) => {
    return requests({
        url: "/api/sms/send",
        method: "post",
        data: qs.stringify(obj)
    })
}
//修改密码
export let changePassword = (data) => {
    return requests({
        url: "/api/user/changepwd",
        method: "post",
        data: qs.stringify(data)
    })
}
//绑定手机
export let bindingMobilePhone = (data) => {
    return requests({
        url: "/api/user/changemobile",
        method: "post",
        data: qs.stringify(data)
    })
}
//绑定备用手机
export let bindingSpareMobilePhone = (data) => {
    return requests({
        url: "/api/user/changesparemobile",
        method: "post",
        data: qs.stringify(data)
    })
}

//用户实名认证信息
export let reqUserCertInfo = () => {
    return requests({
        url: "/api/user/getcertification",
        method: "get"
    })
}

//用户实名认证确认
export let reqUserCertConfirm = (data) => {
    return requests({
        url: "/api/user/idcardConfirm",
        method: "post",
        data: qs.stringify(data)
    })
}

//实人认证
export let reqUserSafe = (data) => {
    return requests({
        url: "/api/user/checkIdcardMatch",
        method: "post",
        data: qs.stringify(data)
    })
}

//身份证正反面认证
export let reqIdcardMatch = (data) => {
    return requests({
        url: "/api/user/idcardImageMatch",
        method: "post",
        data: qs.stringify(data)
    })
}
//用户学历认证信息
export let reqEducationCert = (data) => {
    return requests({
        url: "/api/user/educationCert",
        method: "post",
        data: qs.stringify(data)
    })
}
//获取学历认证信息
export let obtainQualificationInformation = (param) => {
    return requests({
        url: "/api/user/getEducationInfo",
        method: "get",
        params: param
    })
}

//学历认证
export let academicCertification = (data) => {
    return requests({
        url: "/api/user/saveEducation",
        method: "post",
        data: qs.stringify(data)
    })
}


/***********************用户模块end********************/



/********************在线商城模块*******************/

//商城书籍列表
export let reqGoodsList = (param) => {
    return requests({
        url: "/api/apply.Goods/index",
        method: "get",
        params: param
    })
}



/*******************在线商城模块end************/



/******************考试报名模块****************/

//项目列表
export let reqProjectList = (user_id) => {
    return requests({
        url: "/api/apply.Project/index",
        method: "get",
        params: {
            user_id: user_id
        }

    })
}

//报名流程
export let reqProjectDetail = (param) => {
    return requests({
        url: "/api/apply.Project/detail",
        method: "get",
        params: param


    })
}

//报名流程保存
export let reqProjectSavedata = (data) => {
    return requests({
        url: "/api/apply.apply/saveData",
        method: "post",
        data: qs.stringify(data)
    })
}

//购买相关教材
export let reqCreateGoodsOrder = (data) => {
    return requests({
        url: "/api/apply.goods/createGoodsOrder",
        method: "post",
        data: qs.stringify(data)
    })
}

//支付结果查询
export let reqApplyPayResult = (project_id) => {
    return requests({
        url: "/api/apply.pay/qryPayOrder",
        method: "get",
        params: {
            project_id: project_id
        }
    })
}
//缴纳学费支付结果查询
export let reqFeePayResult = (order_id) => {
    return requests({
        url: "/api/apply.pay/qryFeePayOrder",
        method: "get",
        params: {
            order_id: order_id
        }
    })
}
/******************考试报名模块end****************/



//站内邮箱
export let mailbox = (param) => {
    return requests({
        url: "/api/apply.Mailbox/index",
        method: "get",
        params: param
    })
}

//报考职位
export let registeredPosition = (param) => {
    return requests({
        url: "/api/apply.Position/positionInfo",
        method: "get",
        params: param
    })
}

//改报状态查询
export let reqPositionChangeStatus = (param) => {
    return requests({
        url: "/api/apply.Position_change/checkStatus",
        method: "get",
        params: param
    })
}

//改报职位条件验证
export let reqValidatePosition = (data) => {
    return requests({
        url: "/api/apply.Position_change/validatePosition",
        method: "post",
        data: qs.stringify(data)
    })
}

//提交改报
export let reqSubmitPositionChange = (data) => {
    return requests({
        url: "/api/apply.Position_change/submitChange",
        method: "post",
        data: qs.stringify(data)
    })
}






//订单列表
export let orderList = (param) => {
    return requests({
        url: "/api/apply.Order/index",
        method: "get",
        params: param
    })
}

//订单详情
export let orderDetails = (param) => {
    return requests({
        url: "/api/apply.Order/info",
        method: "get",
        params: param
    })
}

//报名表
export let getApplyFile = (param) => {
    return requests({
        url: "api/apply.apply/getApplyFile",
        method: "get",
        params: param
    })
}
//准考证
export let getTicketFile = (param) => {
    return requests({
        url: "api/apply.apply/getTicketFile",
        method: "get",
        params: param
    })
}
//成绩列表
export let scoreList = (param) => {
    return requests({
        url: "/api/apply.Business/index",
        method: "get",
        params: param
    })
}